export function renderSkeleton(): string {
  const rows = Array.from(
    { length: 3 },
    () => `
    <div class="ss-skeleton-row">
      <div class="ss-skeleton-circle"></div>
      <div style="flex:1">
        <div class="ss-skeleton-line ss-skeleton-line-short"></div>
        <div class="ss-skeleton-line ss-skeleton-line-long"></div>
      </div>
    </div>`
  ).join("");

  return `<div class="ss-skeleton">
    <div class="ss-skeleton-header"></div>
    ${rows}
  </div>`;
}

export function renderKbSkeleton(): string {
  const items = Array.from(
    { length: 3 },
    () => `<div class="ss-skeleton-row">
      <div class="ss-skeleton-circle"></div>
      <div style="flex:1">
        <div class="ss-skeleton-line ss-skeleton-line-short"></div>
        <div class="ss-skeleton-line ss-skeleton-line-long"></div>
        <div class="ss-skeleton-line" style="width:75%"></div>
      </div>
    </div>`
  ).join("");

  return `<div class="ss-skeleton">
    <div class="ss-skeleton-header" style="width:40%"></div>
    ${items}
  </div>`;
}

export function renderBannerSkeleton(): string {
  return `<div class="ss-banner ss-banner-skeleton" aria-hidden="true">
    <div class="ss-skeleton-line" style="width:40%;margin:0"></div>
  </div>`;
}

export function renderBlogSkeleton(): string {
  const lines = Array.from(
    { length: 6 },
    (_, i) => `<div class="ss-blog-skeleton-line" style="width: ${i % 3 === 2 ? "60%" : "95%"}"></div>`
  ).join("");

  return `<div class="ss-skeleton" style="padding:16px">
    <div class="ss-blog-skeleton-date"></div>
    <div class="ss-blog-skeleton-title"></div>
    <div style="margin-top:20px">${lines}</div>
  </div>`;
}
